import { defineEntity, custom } from './_helpers.js';

export default defineEntity(
    'gdpr',
    {
        dataSubjectRequest:  custom({ scope: 'state' }),
        'dataBreach.detected': custom({ scope: 'state' }),
        'dataBreach.notified': custom({ scope: 'state' }),
    },
    { includeDefaultLifecycle: false },
);
